import React from 'react';

/**
 * Search + optional filter controls above tables.
 */
const TableToolbar = ({
  search,
  onSearchChange,
  placeholder = 'Search…',
  children,
  resultCount,
  totalCount,
  /** Use inside nested cards / tight layouts */
  compact = false
}) => {
  const hasFilters = children != null && children !== false;

  return (
    <div className={`table-toolbar${compact ? ' table-toolbar--compact' : ''}`}>
      <div className="table-toolbar__search-wrap">
        <input
          type="search"
          className="form-input table-toolbar__search"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={placeholder}
          aria-label={placeholder}
        />
      </div>
      {hasFilters && <div className="table-toolbar__filters">{children}</div>}
      {resultCount != null && totalCount != null && (
        <span className="table-toolbar__count">
          {resultCount} of {totalCount}
        </span>
      )}
    </div>
  );
};

export default TableToolbar;
